import React, { Component } from "react";

const CleaningIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 20"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3655 3.77195H16.1335V0H5.13777V3.77195H7.385L6.38219 5.80164L7.43281 6.32074L8.69211 3.77195H9.11727C9.51219 3.77195 9.83348 4.09328 9.83348 4.4882V5.47527H8.97816V8.9123C8.01969 9.69016 7.39418 10.8629 7.35176 12.1805H0.731914V14.913H0V20H16.1335V12.3236C16.1335 10.9479 15.4976 9.7182 14.5045 8.91227V5.47523H13.6492V4.48816C13.6492 4.09324 13.9705 3.77195 14.3655 3.77195V3.77195ZM6.30965 1.17188H7.74215V2.60008H6.30965V1.17188ZM10.4235 14.9129H9.17242V13.3523H10.4235V14.9129ZM4.3266 14.9129V13.3523H5.57766V14.9129H4.3266ZM6.74953 13.3523H8.00055V14.9129H6.74953V13.3523ZM1.90379 13.3523H3.15477V14.9129H1.90379V13.3523ZM11.1554 18.8281H1.17187V16.0848H11.1554V18.8281ZM14.9616 12.3236V18.8281H12.3273V14.9129H11.5954V12.1805H8.52477C8.59996 10.471 10.0138 9.10332 11.7414 9.10332C13.517 9.10332 14.9616 10.5479 14.9616 12.3236V12.3236ZM11.7414 7.93145C11.1804 7.93145 10.6438 8.03734 10.1501 8.22988V6.64711H13.3327V8.22988C12.839 8.03734 12.3023 7.93145 11.7414 7.93145V7.93145ZM11.0054 5.47523V4.48816C11.0054 3.44707 10.1584 2.60004 9.11731 2.60004H8.91402V1.17188H14.9616V2.60008H14.3655C13.3244 2.60008 12.4773 3.44711 12.4773 4.4882V5.47527H11.0054V5.47523Z"
        fill="black"
      />
    </svg>
  );
};

CleaningIcon.defaultProps = {
  width: 17,
  height: 20,
  fill: "black",
};

export default CleaningIcon;
